import "@minvws/manon/accordion";
import "@minvws/manon/expando-rows";
import "@minvws/manon/filters";
import "@minvws/manon/form-help";
import "@minvws/manon/collapsible";
import "@minvws/manon/language-selector";
import "@minvws/manon/sidemenu";
